import React, { useEffect } from 'react'
import { BtnV2, Loader, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { useLoader } from 'apps/aiAutomation/hooks/useLoader'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { ConfirmSource } from 'apps/aiAutomation/store/layout/types'

import cm from './styles.module.css'

const steps = [
  {
    title: l.makeTranslate('Reading through your page...'),
    subline: l.makeTranslate('Keep this window open to finish the scan'),
  },
  {
    title: l.makeTranslate('Extracting the content...'),
    subline: l.makeTranslate('Don’t leave just yet! This takes a moment.'),
  },
  {
    title: l.makeTranslate('Getting it ready...'),
    subline: l.makeTranslate('Nearly done! Closing now will cancel the scan.'),
  },
  {
    title: l.makeTranslate('Almost set! Review’s up next'),
    subline: l.makeTranslate('Saving your progress...'),
  },
]

export const LinkEntryLoader = ({ showLastStep }: { showLastStep: boolean }) => {
  const dispatch = useAppDispatch()

  const stepIndex = useLoader({
    steps,
    stopAtStep: steps.length - 2,
    showStep: showLastStep ? steps.length - 1 : undefined,
  })

  useEffect(() => {
    dispatch(
      AiAutomationLayoutActions.confirmChanged({
        show: true,
        source: ConfirmSource.SCANNING_LINK,
      }),
    )
    return () => {
      dispatch(
        AiAutomationLayoutActions.confirmChanged({
          show: false,
        }),
      )
    }
  }, [dispatch])

  return (
    <>
      <div className="d-full p-t-xxl text-center">
        <Loader size={24} />
        <h3 className="m-t-lg">{l.getString(steps[stepIndex].title)}</h3>
        <p className={cm.shimmer}>{l.getString(steps[stepIndex].subline)}</p>
      </div>
      <div className="m-t-auto">
        <BtnV2
          label={l.translate('Cancel')}
          ariaLabel={l.translate('Cancel scanning')}
          onClick={() => dispatch(AiAutomationLayoutActions.sidebarClosed())}
        />
      </div>
    </>
  )
}
